export default __webpack_public_path__ + "static/media/flag-grenada.463368a5.svg";